import { render, staticRenderFns } from "./Comp.vue?vue&type=template&id=2dc16381&"
import script from "./Comp.vue?vue&type=script&lang=js&"
export * from "./Comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports